<template>
    <div id="app">
        <div class="show-content">
            <!--          <div class="enter-btn" v-if="status == 1" :style="{backgroundImage: 'url(' + backGroundImg + ')'}"-->
            <!--               @click="appRun"></div>-->
            <div class="loading" v-if="status == 2">
                <div class="round">
                    <div class="top"></div>
                    <div class="round-line"></div>
                </div>
                <div id="percentNum">{{ progress }}%</div>
                <div class="progress_area">
                    <div id="progress" :style="{width: progress+'%'}"></div>
                    <div class="progress-line"></div>
                </div>
            </div>
            <div class="iframe360" id="iframe-360-box" v-if="status != 1">
                <iframe class="iframe" id="iframe_360" :src="iframeUrl"></iframe>
            </div>
            <div class="control-content" :class="showType == 'inter' ? 'innerCar' : ''" v-if="status != 1">
                <div class="t-content">
                    <div class="t-btn" :class=" showType == 'outer' ? 'active' : ''" @click="switchCar('outer')">外观
                    </div>
                    <div class="division"></div>
                    <div class="t-btn" :class=" showType == 'inter' ? 'active' : ''" @click="switchCar('inter')">内室
                    </div>
                </div>
                <div class="select-car" @click="selectCar">
                    <div class="name">
                        {{ selectTypeItem.name }} {{ selectTypeItem.describe }} {{ selectTypeItem.subDescribe }}
                    </div>
                    <div class="arrow"><i class="down" :class="selectCarShow ? 'up' : ''"></i></div>
                    <div class="select-list" v-if="selectCarShow">
                        <div class="item" v-for="(type, index) in viewTypeArr" :key="index"
                             @click.stop="typeSelect(type.code)">
                            <div class="selected" :style="{opacity: type.code===useId ? '1' : '0'}"></div>
                            <div class="name">{{ type.name }} {{ type.describe }} {{ type.subDescribe }}</div>
                        </div>
                    </div>
                </div>
                <outer v-if="showType==='outer'"></outer>
                <inner v-if="showType==='inter'"></inner>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import rx_pc from '../static/img/rx-pc.gif'
import '../utils/app.js'
import outer from './outer'
import inner from './inner'
import {baseUrl} from "@/config";
import {getCameraConfig, paramToString} from "@/utils";

export default {
    name: "index",
    components: {
        outer,
        inner
    },
    mounted() {
        this.CAR = this.getUrlParams().car || 'rz'
        // this.backGroundImg = require(`../static/img/${this.CAR}${document.body.clientWidth > 768?'-pc':''}.gif`)
        this.initPage()
    },
    data() {
        return {
            CAR: '',
            backGroundImg: rx_pc,
            progress: 0,
            iframeUrl: '',
            status: 2,
            selectCarShow: false,
            vmSelectTypeId: ''
        }
    },
    computed: {
        ...mapGetters(['selectTypeItem']),
        ...mapState({
            carConfig: state => state.carConfig,
            selectColorCode: state => state.selectColorCode,
            selectInterCode: state => state.selectInterCode,
            typeArr: state => state.carConfig.typeArr,
            selectTypeId: state => state.selectTypeId,
            showType: state => state.showType,
        }),
        useId: vm => vm.vmSelectTypeId || vm.selectTypeId,
        viewTypeArr: vm => vm.showType === 'inter' ? vm.typeArr.filter(e => !e.interDisSelect) : vm.typeArr
    },
    methods: {
        ...mapActions(['initStore', "setAppState", "setSelectTypeId", "setShowType"]),
        ...mapMutations(['setInitState']),
        getUrlParams(url) {
            let urlData = url || window.location.href
            if (urlData && urlData.charAt(urlData.length - 1) == '#') {
                urlData = urlData.substr(0, urlData.length - 1)
            }
            let urlparams = urlData.split('?')
            if (urlparams.length === 1) {
                return ''
            }
            var newparams = {}
            for (let item of urlparams[1].split('&')) {
                newparams[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
            }
            return newparams
        },
        appRun() {
            // this.iframeUrl = window.location.href.split('lexus_web')[0] + 'officialwebsite/template.html' + `#${this.CAR.toLowerCase()}`
            // `https://cdn.lexus.areyeshot.com/uploads/car-model/newWeb/officialwebsite/template.html#rz`

            const {query = {}, code, name} = this.selectTypeItem
            const queryStr = paramToString({
                ...query,
                car: name.toLowerCase(),
                type: code,
                inter: this.selectInterCode,
                outer: this.selectColorCode,
                camera: encodeURIComponent(getCameraConfig().join(',')),
            })
            this.iframeUrl = `${baseUrl}/officialwebsite/template.html` + `#${queryStr}`;
            this.status = 2
            let _timer = setInterval(() => {
                if (this.progress > 98) {
                    clearInterval(_timer)
                } else {
                    this.progress = (Number(this.progress) + (~~(Math.random() * 10) / 10)).toFixed(0)
                }
            }, 50)

            window.loadFinish = () => {
                this.setInitState(true)
                this.status = 3
            }
        },
        initPage() {
            this.initStore(this.CAR).then(this.appRun)
        },
        switchCar(type) {
            this.setShowType(type)
        },
        selectCar() {
            this.selectCarShow = !this.selectCarShow
        },
        typeSelect(code) {
            this.selectCarShow = false
            if (this.vmSelectTypeId !== code) {
                this.vmSelectTypeId = code
                console.log(this.useId)
                this.setSelectTypeId(this.vmSelectTypeId)
            }
        }
    }
}
</script>

<style lang="less">
.show-content {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: #999999;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .enter-btn {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #d9dae0;
    z-index: 100;
  }

  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99;
    left: 0;
    top: 0;
    background-color: #eee;

      .round{
          display: flex;
          align-items: center;
          justify-content: center;
      }
    .round .top {
        left: 50%;
        top: 50%;
        position: absolute;
        transform: translate(-50%,-50%);
      z-index: 3;
      width: 83px;
      height: 82px;
      background: url("../static/img/loading-3.png") no-repeat;
      background-size: 100% 100%;
    }

    .round .round-line {
        position: relative;
      z-index: 2;
      width: 87px;
      height: 87px;
      background: url("../static/img/loading-2.png") no-repeat;
      background-size: 100% 100%;
      animation: round 2s linear infinite;
    }

    @media (max-width: 768px) {
      .round {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
        width: 84px;
        height: 86px;
        //background: url("../static/img/loading-1-mob.png") no-repeat;
        background-size: 100% 100%;
      }

      .round .top {
        //position: absolute;
        //top: 9px;
        //left: 7px;
        z-index: 3;
        width: 70px;
        height: 69px;
        background: url("../static/img/loading-3-mob.png") no-repeat;
        background-size: 100% 100%;
      }

      .round .round-line {
        //position: absolute;
        //top: 8px;
        //left: 7px;
        z-index: 2;
        width: 70px;
        height: 70px;
        background: url("../static/img/loading-2-mob.png") no-repeat;
        background-size: 100% 100%;
        animation: round 2s linear infinite;
      }
    }
    @media (min-width: 768px) {
      .round {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translateX(-50%);
        width: 101px;
        height: 101px;
        //background: url("../static/img/loading-1.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    @media (min-width: 1200px) {
      .round {
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        width: 101px;
        height: 101px;
        //background: url("../static/img/loading-1.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    @media (min-width: 1480px) {
      .round {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translateX(-50%);
        width: 101px;
        height: 101px;
        //background: url("../static/img/loading-1.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    @keyframes round {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(-360deg);
      }
    }
  }

  .progress_area {
    width: 50vw;
    height: 15px;
    position: absolute;
    top: 60%;
    left: 50%;
    margin-left: -25vw;
    margin-top: -10px;
  }

  .progress_area .progress-line {
    width: 50vw;
    height: 1px;
    border-bottom: 1px solid #999;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -25vw;
    margin-top: -10px;
  }

  #progress {
    width: 0%;
    position: absolute;
    left: 0;
    top: -4px;
    z-index: 4;
    height: 8px;
    border-radius: 8px;
    background-color: #555;
    transition: width 0.2s ease-out;
  }

  @media (max-width: 768px) {
    #progress {
      width: 0%;
      position: absolute;
      left: 0;
      top: -4px;
      z-index: 4;
      height: 5px;
      border-radius: 5px;
      background-color: #555;
      transition: width 0.2s ease-out;
    }
  }

  #percentNum {
    position: absolute;
    top: 62%;
    width: 100px;
    text-align: center;
    left: 50%;
    margin-top: 0;
    margin-left: -50px;
    font-size: 14px;
  }
}

.control-content {
  pointer-events: none;

  div {
    pointer-events: auto;
  }
}

.innerCar {
  .t-content {
    background: linear-gradient(89.98deg, rgba(0, 0, 0, 0) 0.02%, rgba(58, 58, 58, 0.61) 55.26%, rgba(0, 0, 0, 0) 101.03%);

    .t-btn {
      color: #A8A8A8;
    }

    .division {
      background: #A8A8A8;
    }

    .active {
      color: #FFFFFF;
    }
  }

  .select-car {
    .name {
      color: #FFFFFF;
    }

    .arrow {
      background: #FFFFFF;

      .down {
        border-color: #000000;
      }
    }
  }

  .b-content {
    background: linear-gradient(89.98deg, rgba(0, 0, 0, 0) 0.02%, rgba(58, 58, 58, 0.61) 55.26%, rgba(0, 0, 0, 0) 101.03%);

    .swiper-container {
      .swiper-slide-active-item {
        .slide-content {
          .color {
            border: 1px solid #FFFFFF;
          }

          .name {
            color: #FFFFFF;
          }
        }
      }
    }
  }
}
@media (max-height:500px) {
  .iframe360 {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    /* background: #999; */
  }

  .control-content {
    width: 100%;
    height: 100%;
    z-index: 2;
    /*pointer-events: none;*/
    position: absolute;
    left: 0;
    top: 0;
  }

  .t-content {
    width: 100%;
    height: 30px;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);
    position: absolute;
    top: 22px;
    display: flex;
    align-items: center;
    justify-content: center;

    .t-btn {
      font-family: 'MHeiGB';
      font-size: 14px;
      padding: 0 30px;
      color: #A8A8A8;
    }

    .division {
      width: 1px;
      height: 14px;
      background: #000000;
    }

    .active {
      color: #000000;
    }
  }

  .select-car {
    position: absolute;
    top: 29px;
    left: 50px;
    display: flex;
    align-items: center;

    .name {
      font-family: 'Nobel-Book';
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
    }

    .arrow {
      width: 10px;
      height: 10px;
      background: #000000;
      border-radius: 1px;
      margin-left: 13px;
      display: flex;
      align-items: center;
      justify-content: center;

      .down {
        border: 3px solid black;
        border-width: 0px 1px 1px 0px;
        display: inline-block;
        padding: 2px;
        transform: rotate(45deg);
        border-color: #FFFFFF;
        position: relative;
        top: -1px;
      }

      .up {
        transform: rotate(225deg);
        top: 1px;
      }
    }

    .select-list {
      width: 200px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 5px;
      position: absolute;
      top: 30px;

      .item {
        height: 30px;
        margin: 10px 0;
        padding: 0 17px;
        display: flex;
        align-items: center;

        .selected {
          width: 12px;
          height: 12px;
          background: url("../static/img/point.png");
          background-size: 100%;
        }

        .name {
          margin-left: 22px;
          line-height: 30px;
          font-family: 'MHeiGB';
          font-size: 14px;
          color: #FFFFFF;
        }
      }

      .item:hover {
        background: #454545;
      }
    }
  }

  .b-content {
    width: 100%;
    height: 60px;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);
    position: absolute;
    bottom: 10px;
    display: flex;
    justify-content: center;

    .swiper-container {
      width: 1000px;
      margin: 0 50px;
      height: 100%;

      .swiper-slide {
        width: 125px;
        text-align: center;
        font-size: 12px;
        height: 50px;
        padding-top: 5px;
      }

      .slide-content {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .color {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          box-sizing: border-box;

          .color-inner {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            //background: #42b983;
            display: flex;
            overflow: hidden;
            .img-child{
              flex: 1;
            }
          }
        }

        .name {
          width: 100%;
          text-align: center;
          font-family: 'MHeiGB';
          font-size: 12px;
          color: #808080;
          margin-top: 8px;
        }
      }

      .swiper-slide-active-item {
        .slide-content {
          .color {
            border: 1px solid #000000;
            padding: 2px;
          }

          .name {
            color: #000000;
          }
        }
      }
    }

    .number360d {
      width: 60px;
      height: 22px;
      background: url("../static/img/360.png");
      background-size: 100%;
      position: absolute;
      //left: 50px;
      top: -34px;
    }

    .swiper-button-prev, .swiper-button-next {
      color: #000000;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
      font-size: 13px;
    }
  }
}
@media (min-width: 960px) and (min-height:500px) {
  .iframe360 {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    /* background: #999; */
  }

  .control-content {
    width: 100%;
    height: 100%;
    z-index: 2;
    /*pointer-events: none;*/
    position: absolute;
    left: 0;
    top: 0;
  }

  .t-content {
    width: 100%;
    height: 60px;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);
    position: absolute;
    top: 44px;
    display: flex;
    align-items: center;
    justify-content: center;

    .t-btn {
      font-family: 'MHeiGB';
      font-size: 24px;
      padding: 0 30px;
      color: #A8A8A8;
    }

    .division {
      width: 1px;
      height: 24px;
      background: #000000;
    }

    .active {
      color: #000000;
    }
  }

  .select-car {
    position: absolute;
    top: 58px;
    left: 100px;
    display: flex;
    align-items: center;

    .name {
      font-family: 'Nobel-Book';
      font-style: normal;
      font-weight: 300;
      font-size: 24px;
    }

    .arrow {
      width: 20px;
      height: 20px;
      background: #000000;
      border-radius: 2px;
      margin-left: 27px;
      display: flex;
      align-items: center;
      justify-content: center;

      .down {
        border: 3px solid black;
        border-width: 0px 2px 2px 0px;
        display: inline-block;
        padding: 4px;
        transform: rotate(45deg);
        border-color: #FFFFFF;
        position: relative;
        top: -2px;
      }

      .up {
        transform: rotate(225deg);
        top: 3px;
      }
    }

    .select-list {
      width: 400px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 10px;
      position: absolute;
      top: 60px;

      .item {
        height: 60px;
        margin: 20px 0;
        padding: 0 35px;
        display: flex;
        align-items: center;

        .selected {
          width: 24px;
          height: 24px;
          background: url("../static/img/point.png");
          background-size: 100%;
        }

        .name {
          margin-left: 45px;
          line-height: 60px;
          font-family: 'MHeiGB';
          font-size: 24px;
          color: #FFFFFF;
        }
      }

      .item:hover {
        background: #454545;
      }
    }
  }

  .b-content {
    width: 100%;
    height: 100px;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);
    position: absolute;
    bottom: 20px;
    display: flex;
    justify-content: center;

    .swiper-container {
      width: 1000px;
      margin: 0 50px;
      height: 100%;

      .swiper-slide {
        width: 125px;
        text-align: center;
        font-size: 18px;
        height: 100px;
        padding-top: 10px;
      }

      .slide-content {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .color {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          box-sizing: border-box;

          .color-inner {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            //background: #42b983;
              display: flex;
              overflow: hidden;
              .img-child{
                  flex: 1;
              }
          }
        }

        .name {
          width: 100%;
          text-align: center;
          font-family: 'MHeiGB';
          font-size: 16px;
          color: #808080;
          margin-top: 15px;
        }
      }

      .swiper-slide-active-item {
        .slide-content {
          .color {
            border: 1px solid #000000;
            padding: 4px;
          }

          .name {
            color: #000000;
          }
        }
      }
    }

    .number360d {
      width: 120px;
      height: 44px;
      background: url("../static/img/360.png");
      background-size: 100%;
      position: absolute;
      left: 50%;
      top: -64px;
      transform: translateX(-50%);
    }

    .swiper-button-prev, .swiper-button-next {
      color: #000000;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
      font-size: 26px;
    }
  }
}

@media (max-width: 960px) and (min-height:500px) {
  .iframe360 {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    /* background: #999; */
  }

  .control-content {
    width: 100%;
    height: 100%;
    z-index: 2;
    /*pointer-events: none;*/
    position: absolute;
    left: 0;
    top: 0;
  }

  .t-content {
    width: 100%;
    height: 30px;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);
    position: absolute;
    bottom: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      pointer-events: auto;
    }

    .t-btn {
      font-family: 'MHeiGB';
      font-size: 14px;
      padding: 0 30px;
      color: #A8A8A8;
    }

    .division {
      width: 1px;
      height: 14px;
      background: #000000;
    }

    .active {
      color: #000000;
    }
  }

  .select-car {
    width: 100%;
    height: 30px;
    position: absolute;
    top: 50px;
    justify-content: center;
    display: flex;
    align-items: center;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);

    .name {
      font-family: 'Nobel-Book';
      font-style: normal;
      font-size: 14px;
    }

    .arrow {
      width: 16px;
      height: 16px;
      background: #000000;
      border-radius: 2px;
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      .down {
        border: 3px solid black;
        border-width: 0px 2px 2px 0px;
        display: inline-block;
        padding: 3px;
        transform: rotate(45deg);
        border-color: #FFFFFF;
        position: relative;
        top: -2px;
      }

      .up {
        transform: rotate(225deg);
        top: 2px;
      }
    }

    .select-list {
      width: 240px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 10px;
      position: absolute;
      top: 38px;

      .item {
        height: 50px;
        padding: 0 35px;
        display: flex;
        align-items: center;

        .selected {
          width: 14px;
          height: 14px;
          background: url("../static/img/point.png");
          background-size: 100% 100%;
        }

        .name {
          margin-left: 10px;
          line-height: 50px;
          font-family: 'MHeiGB';
          font-size: 14px;
          color: #FFFFFF;
        }
      }

      .item:hover {
        background: #454545;
      }
    }
  }

  .b-content {
    width: 100%;
    background: linear-gradient(89.98deg, rgba(255, 255, 255, 0) 0.02%, rgba(255, 255, 255, 0.61) 55.26%, rgba(255, 255, 255, 0) 101.03%);
    position: absolute;
    bottom: 102px;
    display: flex;
    justify-content: center;

    .swiper-container {
      width: 100%;
      height: 100%;
      margin: 0 50px;

      .swiper-slide {
        width: 80px;
        text-align: center;
        font-size: 18px;
        padding: 10px 0px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      .slide-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;

        .color {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #42b983;
          box-sizing: border-box;

          .color-inner {
            width: 100%;
            height: 100%;
            border-radius: 50%;
              display: flex;
              overflow: hidden;
              .img-child{
                  flex: 1;
              }
          }
        }

        .name {
          width: 100%;
          text-align: center;
          font-family: 'MHeiGB';
          font-size: 12px;
          color: #808080;
          margin-top: 8px;
        }
      }

      .swiper-slide-active-item {
        .slide-content {
          .color {
            border: 1px solid #000000;
            padding: 4px;
          }

          .name {
            color: #000000;
          }
        }
      }
    }

    .number360d {
      width: 75px;
      height: 28px;
      background: url("../static/img/360.png");
      background-size: 100%;
      position: absolute;
      left: 50%;
      top: -55px;
      transform: translateX(-50%);
    }

    .swiper-button-prev, .swiper-button-next {
      color: #000000;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
      font-size: 26px;
    }
  }
}
</style>
